export default "__VITE_ASSET__VRAGABNm__"